import { useQuery } from "@tanstack/react-query";
import { api } from "utils/hostname";
import url from "../../../../../url";
import type { FortuneWheelListResponse } from "../type/FortuneWheel";
import { useFortuneWheelStore } from "../store/fortuneWheel";

export const useConfigWheel = () => {
  const setSectionList = useFortuneWheelStore((s) => s.setSectionList);
  const setError = useFortuneWheelStore((s) => s.setError);

  return useQuery<FortuneWheelListResponse>({
    queryKey: ["fortuneWheel", "config"],
    queryFn: async () => {
      const res = await api(true, true).get<FortuneWheelListResponse>(
        url.config.api.fortuneWheel.config,
      );
      const payload = res.data;

      if (!payload || !Array.isArray(payload.sections)) {
        setError("config_failed");
        throw new Error("Invalid fortune wheel config payload");
      }

      setSectionList(payload);

      return payload;
    },
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
    refetchOnWindowFocus: false,
    retry: 2,
  });
};
